import React from "react";
import {
Box,
Container,
Row,
Column,
FooterLink,
Heading,
} from "./FooterStyles";

const Footer = () => {
return (
	<Box>
	<Container>
		{/* <Row>
		<Column>
			<Heading>About Us</Heading>
			<FooterLink href="#">Vision</FooterLink>
		</Column>
		<Column>
			<Heading>Services</Heading>
			<FooterLink href="#">Eduscope</FooterLink>
			<FooterLink href="#">Digital Library</FooterLink>
		</Column>
		<Column>
			<Heading>Contact Us</Heading>
			<FooterLink href="#">Student Services</FooterLink>
			<FooterLink href="#">Staff Services</FooterLink>
		</Column>
		
		</Row> */}
		Developed by: SD01
	</Container>
	</Box>
);
};
export default Footer;
